import { render, staticRenderFns } from "./EditQuestionAnswer.vue?vue&type=template&id=0ade6ee8"
import script from "./EditQuestionAnswer.vue?vue&type=script&lang=js"
export * from "./EditQuestionAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports